import { useGateValue } from '@coursera-web/statsig';

// SEARCH-2412: gates the "Micro Lessons" filter toggle (both the filters2024 chip UI and the
// generic admin/inline filter groups) so it can be rolled back quickly without a code change.
const useIsMicroLessonsRolloutEnabled = (): boolean => useGateValue('search-micro-lessons-rollout');

export default useIsMicroLessonsRolloutEnabled;
